export function findLabel(collection, id) {
  const v = (collection || []).find(c => c.id == id)
  return v ? v.name : null
}

export function findElement(collection, id) {
  const v = (collection || []).find(c => c.id == id)
  return v
}

export function percentageSeen(elem, elemHeight) {
  const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  const scrollTop = Math.max(document.documentElement.scrollTop, window.pageYOffset || 0)
  const elementOffsetTop = getOffset(elem).top

  if (elementOffsetTop > (scrollTop + viewportHeight)) {
    return 0
  } else if ((elementOffsetTop + elemHeight) < (scrollTop + viewportHeight)) {
    return 100
  } else {
    const distance = (scrollTop + viewportHeight) - elementOffsetTop
    let percentage = distance / (elemHeight / 100)
    percentage = Math.round(percentage)
    return percentage
  }
}

function getOffset(elem) {
  if (elem && elem.getBoundingClientRect) {
    // "правильный" вариант
    return getOffsetRect(elem)
  } else {
    // пусть работает хоть как-то
    return getOffsetSum(elem)
  }
}

function getOffsetSum(elem) {
  let top = 0, left = 0
  while (elem) {
    top = top + parseInt(elem.offsetTop)
    left = left + parseInt(elem.offsetLeft)
    elem = elem.offsetParent
  }

  return {top: top, left: left}
}

function getOffsetRect(elem) {
  // (1)
  let box = elem.getBoundingClientRect()

  // (2)
  let body = document.body
  let docElem = document.documentElement

  // (3)
  let scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
  let scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft

  // (4)
  let clientTop = docElem.clientTop || body.clientTop || 0
  let clientLeft = docElem.clientLeft || body.clientLeft || 0

  // (5)
  let top = box.top + scrollTop - clientTop
  let left = box.left + scrollLeft - clientLeft

  return {top: Math.round(top), left: Math.round(left)}
}

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}


// WEBPACK FOOTER //
// ./src/finwhale/utils.js